import script from "./Structure.vue?vue&type=script&setup=true&lang=js"
export * from "./Structure.vue?vue&type=script&setup=true&lang=js"

import "./Structure.vue?vue&type=style&index=0&id=3877ec01&lang=scss"

const __exports__ = script;

export default __exports__